@if (open) {
  <div class="tkc-backdrop" (click)="close()">
    <div class="tkc" role="dialog" aria-modal="true" aria-labelledby="tkc-title" (click)="$event.stopPropagation()">
      <div class="tkc-head">
        <span class="tkc-eyebrow">
          <span class="material-symbols-outlined">add_task</span>
          {{ parentTaskId ? 'New sub-task' : 'New task' }}
        </span>
        <button type="button" class="tkc-x" (click)="close()" aria-label="Close"><span class="material-symbols-outlined">close</span></button>
      </div>

      @if (parentTitle) {
        <div class="tkc-parent"><span class="material-symbols-outlined">subdirectory_arrow_right</span> Sub-task of <b>{{ parentTitle }}</b></div>
      }

      <textarea
        #titleEl
        id="tkc-title"
        class="tkc-title"
        rows="1"
        placeholder="What needs to be done?"
        [(ngModel)]="title"
        (input)="autosize(titleEl)"
        (keydown)="onTitleKey($event)"
        maxlength="200"
      ></textarea>

      <div class="tkc-row">
        @if (actsFor.length) {
          <span class="tkc-from" (click)="$event.stopPropagation()">
            <button type="button" class="tkc-chip from" [class.on]="onBehalfOf" (click)="fromOpen = !fromOpen">
              <span class="material-symbols-outlined">badge</span>
              <span class="l">From</span> {{ onBehalfOf ? onBehalfOf.name : 'Me' }}
              <span class="material-symbols-outlined caret">expand_more</span>
            </button>
            @if (fromOpen) {
              <div class="tkc-from-menu">
                <button type="button" (click)="pickFrom(null)"><span class="material-symbols-outlined">person</span>Me</button>
                @for (a of actsFor; track a.userId) {
                  <button type="button" (click)="pickFrom(a)"><tk-avatar [person]="a" [size]="20"></tk-avatar>{{ a.name }}<small>in their name, via you</small></button>
                }
              </div>
            }
          </span>
        }
        <tk-people-picker [departments]="true" [everyone]="!parentTaskId || true" [chosen]="chosenKeys" placeholder="Search people or departments… pick several for a group task" (picked)="onPick($event)">
          <span class="tkc-chip who" [class.dept]="targetDept" [class.group]="isGroup">
            @if (targetPerson) {
              <tk-avatar [person]="targetPerson" [size]="18"></tk-avatar>
            } @else if (isGroup) {
              <span class="material-symbols-outlined">diversity_3</span>
            } @else if (targetDept) {
              <span class="material-symbols-outlined">inbox</span>
            } @else {
              <span class="material-symbols-outlined">person</span>
            }
            <span class="l">For</span> {{ targetLabel }}
            <span class="material-symbols-outlined caret">expand_more</span>
          </span>
        </tk-people-picker>

        <span class="tkc-from" (click)="$event.stopPropagation()">
          <button type="button" class="tkc-chip type" [class.on]="type !== 'general'" (click)="toggleType()" title="What kind of task is this?">
            <span class="material-symbols-outlined">{{ typeDef?.icon || 'task' }}</span>
            <span class="l">Type</span> {{ typeDef?.label || 'General' }}
            @if (typeAuto && type !== 'general') {
              <span class="material-symbols-outlined auto" title="Tagged from the title; click to change">auto_awesome</span>
            }
            <span class="material-symbols-outlined caret">expand_more</span>
          </button>
          @if (typeOpen) {
            <div class="tkc-from-menu tkc-type-menu">
              <input #typeSearch type="search" class="tkc-type-search" placeholder="Search types…" [(ngModel)]="typeQuery" />
              @if (!typeQuery && suggestedTypes.length) {
                <div class="tkc-type-group">
                  <h5>Common for you</h5>
                  <div class="tkc-type-chips">
                    @for (t of suggestedTypes; track t.id) {
                      <button type="button" [class.on]="type === t.id" (click)="pickType(t.id)"><span class="material-symbols-outlined">{{ t.icon }}</span>{{ t.label }}</button>
                    }
                  </div>
                </div>
              }
              <div class="tkc-type-list">
                @for (g of typeGroups; track g.id) {
                  <div class="tkc-type-group">
                    <h5>{{ g.label }}</h5>
                    <div class="tkc-type-chips">
                      @for (t of g.types; track t.id) {
                        <button type="button" [class.on]="type === t.id" (click)="pickType(t.id)"><span class="material-symbols-outlined">{{ t.icon }}</span>{{ t.label }}</button>
                      }
                    </div>
                  </div>
                } @empty {
                  <p class="tkc-rep-note">No type matches “{{ typeQuery }}”.</p>
                }
              </div>
            </div>
          }
        </span>

        <tk-due-picker [value]="dueDate" (valueChange)="dueDate = $event" [withTime]="true" [time]="dueTime" (timeChange)="dueTime = $event">
          <span class="tkc-chip due" [class.today]="dueClass === 'today'" [class.overdue]="dueClass === 'overdue'">
            <span class="material-symbols-outlined">{{ dueTime ? 'alarm' : 'event' }}</span>
            <span class="l">Due</span> {{ dueLabel }}@if (dueTime) {<span class="t"> · {{ timeLabel }}</span>}
            <span class="material-symbols-outlined caret">expand_more</span>
          </span>
        </tk-due-picker>

        @if (canBackdate && !repeatFreq) {
          <span class="tkc-from" (click)="$event.stopPropagation()">
            <button type="button" class="tkc-chip start" [class.on]="startLabel !== 'Today'" (click)="openStartPicker(startInput)" title="Admins only, until 27 Oct 2026: the day this work actually started. The task then counts from that day.">
              <span class="material-symbols-outlined">history</span>
              <span class="l">Started</span> {{ startLabel }}
              <span class="material-symbols-outlined caret">expand_more</span>
            </button>
            <input #startInput type="date" class="tkc-start-input" [class.shown]="startPickerInline" [ngModel]="startedOn || ''" (ngModelChange)="startedOn = $event || null" [min]="startMinYMD" [max]="todayYMD" aria-label="Start date (Admins only, back-dates the task)" />
          </span>
        }

        <span class="tkc-from" (click)="$event.stopPropagation()">
          <button type="button" class="tkc-chip rep" [class.on]="repeatFreq" (click)="repeatOpen = !repeatOpen; fromOpen = false" [disabled]="!!parentTaskId" [title]="parentTaskId ? 'Sub-tasks do not repeat' : 'Repeat this task'">
            <span class="material-symbols-outlined">repeat</span>
            <span class="l">Repeats</span> {{ repeatLabel }}
            <span class="material-symbols-outlined caret">expand_more</span>
          </button>
          @if (repeatOpen) {
            <div class="tkc-from-menu tkc-rep-menu">
              <div class="tkc-rep-opts">
                <button type="button" [class.on]="!repeatFreq" (click)="setRepeat('')">Never</button>
                <button type="button" [class.on]="repeatFreq === 'daily'" (click)="setRepeat('daily')">Daily</button>
                <button type="button" [class.on]="repeatFreq === 'weekly'" (click)="setRepeat('weekly')">Weekly</button>
                <button type="button" [class.on]="repeatFreq === 'monthly'" (click)="setRepeat('monthly')">Monthly</button>
                <button type="button" [class.on]="repeatFreq === 'quarterly'" (click)="setRepeat('quarterly')">Quarterly</button>
              </div>
              @if (repeatFreq === 'weekly') {
                <div class="tkc-rep-days">
                  @for (d of dow; track $index) {
                    <button type="button" [class.on]="repeatDays.includes($index)" (click)="toggleDay($index)" [title]="dowFull[$index]">{{ d }}</button>
                  }
                </div>
              }
              @if (repeatFreq === 'monthly' || repeatFreq === 'quarterly') {
                <p class="tkc-rep-note">On the {{ dueDay }}{{ dueDay === 1 || dueDay === 21 || dueDay === 31 ? 'st' : dueDay === 2 || dueDay === 22 ? 'nd' : dueDay === 3 || dueDay === 23 ? 'rd' : 'th' }} of the month, from the due date. Shorter months use their last day.</p>
              }
              @if (repeatFreq) {
                <label class="tkc-rep-until"><span>Until (optional)</span><input type="date" [ngModel]="repeatEnds || ''" (ngModelChange)="repeatEnds = $event || null" [min]="dueDate || ''" /></label>
                <p class="tkc-rep-note">Each occurrence is its own task. The next one appears when the current is closed, or on its date if the current is still open, so missed ones stay overdue.</p>
              }
            </div>
          }
        </span>

        <span class="tkc-from" (click)="$event.stopPropagation()">
          <button type="button" class="tkc-chip proof" [class.on]="proofKinds.length > 0" (click)="toggleProof()" title="What must be attached before this can be marked done?">
            <span class="material-symbols-outlined">{{ proofIcon }}</span>
            <span class="l">Proof</span> {{ proofShort || 'not needed' }}
            <span class="material-symbols-outlined caret">expand_more</span>
          </button>
          @if (proofOpen) {
            <div class="tkc-from-menu tkc-proof-menu">
              <p class="tkc-menu-title">Before it can be marked done, the person must attach (pick one or several):</p>
              <div class="tkc-rep-opts">
                <button type="button" [class.on]="!proofKinds.length" (click)="pickProof('none')"><span class="material-symbols-outlined">do_not_disturb_on</span>No proof needed</button>
                @for (k of proofDefs; track k.id) {
                  <button type="button" [class.on]="hasProof(k.id)" (click)="pickProof(k.id)"><span class="material-symbols-outlined">{{ k.icon }}</span>{{ k.label }}</button>
                }
              </div>
              @if (proofKinds.length) {
                <label class="tkc-rep-until"><span>What exactly (optional)</span><input type="text" [(ngModel)]="proofNote" maxlength="200" placeholder="e.g. photo of the repaired unit, the updated sheet" /></label>
              }
              <p class="tkc-rep-note">{{ proofAuto ? 'Set from the task type; change it if this one is different.' : 'Set by you for this task.' }}</p>
            </div>
          }
        </span>

        <button type="button" class="tkc-chip flag" [class.on]="priority === 'high'" (click)="togglePriority()" [title]="priority === 'high' ? 'Urgent — click to clear' : 'Mark urgent'">
          <span class="material-symbols-outlined">flag</span>
          {{ priority === 'high' ? 'Urgent' : 'Normal' }}
        </button>
      </div>

      @if (isGroup) {
        <div class="tkc-targets">
          <span class="tkc-targets-label"><span class="material-symbols-outlined">diversity_3</span>Group task · one task each for</span>
          @for (t of targets; track $index; let i = $index) {
            <span class="tkc-target">{{ targetName(t) }}<button type="button" (click)="removeTarget(i)" aria-label="Remove"><span class="material-symbols-outlined">close</span></button></span>
          }
          <span class="tkc-targets-note">{{ parentTaskId ? 'Each becomes a sub-task of the parent.' : 'You see one card with progress; each person sees only their own.' }}</span>
        </div>
      }

      @if (link) {
        <div class="tkc-link">
          <span class="material-symbols-outlined">link</span>
          <span class="t">About</span>
          <span class="n">{{ link.label || link.type }}</span>
          <button type="button" class="rm" (click)="link = null" aria-label="Remove link"><span class="material-symbols-outlined">close</span></button>
        </div>
      }

      @if (showDetails) {
        <textarea class="tkc-details" rows="3" placeholder="Details, context, what good looks like… (optional)" [(ngModel)]="details" maxlength="5000"></textarea>
      }

      @if (files.length) {
        <div class="tkc-files">
          @for (f of files; track f.url; let i = $index) {
            <span class="tkc-file"><span class="material-symbols-outlined">attach_file</span>{{ f.name }}<button type="button" (click)="removeFile(i)" aria-label="Remove file"><span class="material-symbols-outlined">close</span></button></span>
          }
        </div>
      }

      <div class="tkc-tools">
        @if (!showDetails) {
          <button type="button" class="tkc-tool" (click)="showDetails = true"><span class="material-symbols-outlined">notes</span> Add details</button>
        }
        <button type="button" class="tkc-tool" (click)="fileEl.click()" [disabled]="uploading">
          <span class="material-symbols-outlined">attach_file</span> {{ uploading ? 'Uploading…' : 'Attach' }}
        </button>
        <input #fileEl type="file" multiple hidden (change)="onFiles($event)" accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.png,.jpg,.jpeg,.webp,.svg,.gif,.txt" />
      </div>

      @if (error) {
        <div class="tkc-error">{{ error }}</div>
      }

      <div class="tkc-foot">
        <span class="tkc-hint"><kbd>Enter</kbd> creates · <kbd>Esc</kbd> closes</span>
        <div class="tkc-actions">
          <button type="button" class="tkc-btn quiet" (click)="close()" [disabled]="saving">Cancel</button>
          <button type="button" class="tkc-btn primary" (click)="save()" [disabled]="saving || uploading">
            <span class="material-symbols-outlined">check</span>{{ saving ? 'Creating…' : 'Create task' }}
          </button>
        </div>
      </div>
    </div>
  </div>
}
